<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <h4 class="card-title float-left" v-if="companyTariff.id!=null">{{$t('companyTariff.titleEdit')}}</h4>
                                <h4 class="card-title float-left" v-else>{{$t('companyTariff.addNew')}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-group pr-3">
                                    <label>{{$t('companyTariff.companyTariffType')}}<span class="red">*</span></label>
                                    <CompanyTariffTypeSelect :value="companyTariff.companyTariffType" v-model="companyTariff.companyTariffType"></CompanyTariffTypeSelect>
                                    <div class="red" v-if="$v.companyTariff.companyTariffType.$error">
                                        {{$t('companyTariff.companyTariffType')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('companyTariff.name')}}<span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="companyTariff.name"
                                           :class="{invalid : $v.companyTariff.name.$error}"/>
                                    <div class="red" v-if="$v.companyTariff.name.$error">
                                        {{$t('companyTariff.name')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('companyTariff.qty')}}<span class="red">*</span></label>
                                    <numeric-input v-model="companyTariff.qty" :placeholder="$t('companyTariff.qty')">
                                    </numeric-input>
                                    <div class="red" v-if="$v.companyTariff.qty.$error">
                                        {{$t('companyTariff.qty')}}
                                    </div>
                                </div>
                                <div class="form-group pr-3">
                                    <label>{{$t('companyTariff.measurementType')}}<span class="red">*</span></label>
                                    <MeasurementTypeSelect :value="companyTariff.measurementType" v-model="companyTariff.measurementType"></MeasurementTypeSelect>
                                    <div class="red" v-if="$v.companyTariff.measurementType.$error">
                                        {{$t('companyTariff.measurementType')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('companyTariff.amount')}}<span class="red">*</span></label>
                                    <numeric-input v-model="companyTariff.amount" :placeholder="$t('companyTariff.amount')">
                                    </numeric-input>
                                    <div class="red" v-if="$v.companyTariff.amount.$error">
                                        {{$t('companyTariff.amount')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('companyTariff.description')}}<span class="red">*</span></label>
                                    <textarea
                                            cols="30" rows="3"
                                            class="form-control"
                                            v-model="companyTariff.description"
                                            :class="{invalid : $v.companyTariff.description.$error}"
                                    ></textarea>
                                    <div class="red" v-if="!$v.companyTariff.description.minLength">
                                        Узунлиги 5 тадан кам булмаслиги керак
                                    </div>
                                    <div class="red" v-if="$v.companyTariff.description.$error">
                                        {{$t('companyTariff.description')}}
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" @click="save"
                                        :disabled="processing" v-if="save">
                                    {{$t("action.save")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required,minLength} from 'vuelidate/lib/validators';
    // import {EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
    import initFilterModel from '@/shared/filter';
    // import DatePicker from 'vuejs-datepicker';
    import {formatDate, parseDate} from '@/shared/utils';
    import MeasurementTypeSelect from '@/components/MeasurementTypeSelect'
    import CompanyTariffTypeSelect from '@/views/company/CompanyTariffTypeSelect'
    // import {BASE_API} from '@/axios';

    export default {
        name: "CompanyTariffAddEditView",
        components: {
            CompanyTariffTypeSelect,
            MeasurementTypeSelect
        },
        data() {
            return {
                parseDate: parseDate,
                formatDate: formatDate,
                processing: false,
                loading: {
                    isDocQrLoading: false,
                },
                ownerFilter: initFilterModel(),
                editIndex: null,
                loadingExcelCalc: false,
                companyTariff: {
                    id: null,
                    name: null,
                    qty: null,
                    amount: null,
                    measurementType: null,
                    description: null,
                },
                itemFilter: initFilterModel(),
                results: null
            }
        },
        validations() {
            return {
                companyTariff: {
                    companyTariffType: {
                        required: required
                    },
                    name: {
                        required: required
                    },
                    qty: {
                        required: required
                    },
                    amount: {
                        required: required
                    },
                    measurementType: {
                        required: required
                    },
                    description: {
                        required: required,
                        minLength: minLength(5)
                    },

                }
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                if (id && id > 0) {
                    this.$http.get('/companies-tariff/' + id)
                        .then(res => {
                            console.log(res);
                            vm.companyTariff = res.data;
                            this.processing = false;
                        }, () => {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.fixedExpense.error'),
                                type: 'error'
                            });
                            this.processing = false;
                        })

                }
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                this.$http.post('/companies-tariff/save', this.companyTariff)
                    .then(res => {
                        console.log(res)
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.companyTariff.success'),
                            type: 'success'
                        });
                        this.$router.push('/config/companies-tariff');
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.companyTariff.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    })

            },
            cancel() {
                this.$router.push('/config/companies-tariff');
            },

        },
        computed: {

        },
        created() {
           this.init();
        }
    }
</script>

<style scoped>
    .custom {
        font-family: "Trebuchet MS",Arial,Helvetica,sans-serif;
        border-collapse: collapse;
        width: 100%;
    }
    .custom td,.custom th{
        border: 1px solid #ddd;
        padding: 4px;
    }
    .custom tr:nth-child(even){
        background-color: #f2f2f2;
    }
    .custom tr:hover{
        opacity: 1;
        background-color: #dee2e6;
    }
    .custom thead tr th{
        border-bottom-width: 1px;
        padding-top: 4px;
        padding-bottom: 4px;
        text-align: center !important;
        color: #9A9A9A;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: 400;
    }
    .custom tr{
        font-size: 14px;
    }

</style>